<template>
  <div>
    <h3 class="mb-3">{{ data.title }}</h3>

    <apex-chart
      type="pie"
      :options="chartOptions"
      :series="series"
      @dataPointSelection="dataPointSelectionHandler"
      :height="250"
    ></apex-chart>
  </div>
</template>

<script>
import apexChart from "vue-apexcharts";
export default {
  name: "pie-chart",
  components: {
    apexChart,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        plotOptions: {
          pie: {},
        },
        labels: [],
        chart: {
          type: "donut",
        },
        colors: [
          "#CD6155",
          "#9B59B6",
          "#2980B9",
          "#48C9B0",
          "#F4D03F",
          "#D35400",
          "#212F3D",
          "#641E16",
          "#00FF00",
          "#0000FF",
          "#999999",
          "AQUA",
        ],
      },
      events: {
        click: function (event, chartContext, config) {
          console.log("click");
        },
        dataPointSelection: function (event, chartContext, config) {
          console.log("dataPointSelection");
        },
      },
    };
  },
  mounted() {
    this.series = [];
    this.chartOptions.labels = [];
    let labels = [];
    for (let i = 0; i < this.data.data.length; i++) {
      this.series.push(this.data.data[i].value);
      labels.push(this.data.data[i].key);
    }
    this.chartOptions = {
      labels: labels,
    };
    console.log(this.series);
    console.log(this.chartOptions);
  },
  methods: {
    dataPointSelectionHandler(e, chartContext, config) {
      console.log(chartContext, config);
    },
  },
  watch: {
    data() {
      this.series = [];
      this.chartOptions.labels = [];
      let labels = [];
      for (let i = 0; i < this.data.data.length; i++) {
        this.series.push(this.data.data[i].value);
        labels.push(this.data.data[i].key);
      }
      this.chartOptions = {
        labels: labels,
      };
      console.log(this.series);
      console.log(this.chartOptions);
    },
  },
};
</script>

<style scoped></style>
